import React from 'react';
import styled from 'styled-components';
import { BREAKPOINTS } from '../../styles/variables';
import SvgSelector from './SvgSelector';

const ArrowButton = ({ backDirection = false, ...props }) => {
  return (
    <ArrowButtonWr {...props} $backDirection={backDirection}>
      <SvgSelector svg='arrow' />
    </ArrowButtonWr>
  );
};

const ArrowButtonWr = styled.button`
  width: 70px;
  height: 70px;
  border-radius: 50%;

  display: flex;
  justify-content: center;
  align-items: center;

  background-color: rgba(255, 255, 255, 1);
  transition: background-color 0.2s;

  border-radius: 50%;
  svg {
    width: 100%;
    height: 100%;
    transform: rotate(${({ $backDirection }) => ($backDirection ? '180deg' : '0deg')});
  }

  &:hover {
    background-color: rgba(210, 210, 210, 1);
  }

  @media ${BREAKPOINTS.laptop} {
    width: 5vw;
    height: 5vw;
  }
  @media ${BREAKPOINTS.mobile} {
    width: 10.42vw;
    height: 10.42vw;
  }
`;

export default ArrowButton;
